
import Vue from 'vue'
import BinnacleTransformer from './../../transformers/sinister/binnacle'

export default (affectedId) => {
  return Vue.$http.get(`sinisters/affected/${affectedId}/binnacle/`)
    .then(response => {
      const data = response.data
      const transformed = BinnacleTransformer.fetchCollection(data)
      return transformed
    })
}


// WEBPACK FOOTER //
// ./src/services/sinister/fetchBinnacle.js